import PropTypes from "prop-types";
import Button from "components/shared/button/Button";

const HideOrShowPasswordButton = ({
  isPasswordShown,
  setIsPasswordShown,
  className,
}) => {
  return (
    <Button
      buttonType="text"
      onClick={setIsPasswordShown}
      className={className}
    >
      <img
        height={"20px"}
        width={"20px"}
        src={
          isPasswordShown
            ? "./img/hide-password.svg"
            : "./img/show-password.svg"
        }
        alt="Hide/Show Password"
      />
    </Button>
  );
};

export default HideOrShowPasswordButton;

HideOrShowPasswordButton.propTypes = {
  isPasswordShown: PropTypes.bool.isRequired,
  setIsPasswordShown: PropTypes.func.isRequired,
  className: PropTypes.string,
};
